import React from "react";
import { transformComma } from "../../../utils/validator/comma";
import PerfectScrollbar from 'react-perfect-scrollbar';

const IndividualDecisions = ({ data }) => {
  if (!data) {
    return <p>데이터가 없습니다.</p>;
  }

  const pensionData = data;
  const personList = pensionData?.list || []; // 건강보험료 대상자 리스트

  // 값이 없을 경우 기본값 설정 함수

  return (
    <div className="si4n-detail">
      <h4 className="si4n-title">건강보험료 고지(산출) 내역서</h4>

      {/* 국민건강보험료 결정내역 테이블 */}
      <div className="scroll-table">
        <PerfectScrollbar>
          <table className="si4n-table stichy-row stichy-col">
            <thead>
              <tr>
                <th>이름</th>
                <th>증번호</th>
                <th>주민번호</th>
                <th>월보수액</th>
                <th>건강산출보험료</th>
                <th>건강정산보험료</th>
                <th>강연말정산</th>
                <th>건강환급이자</th>
                <th>건강고지보험료</th>
                <th>건강정산사유</th>
                <th>정산적용기간(시작)</th>
                <th>정산적용기간(종료)</th>
                <th>요양산출보험료</th>
                <th>요양정산보험료</th>
                <th>요양연말정산</th>
                <th>요양환급이자</th>
                <th>요양고지보험료</th>
                <th>취득일</th>
                <th>상실일</th>
                <th>요양정산사유</th>
                <th>요양정산적용기간(시작)</th>
                <th>요양정산적용기간(종료)</th>
              </tr>
            </thead>
            <tbody>
              {personList.map((item, index) => (
                <tr key={index}>
                  {/* <td>{item.no}</td> */}
                  <td>{item.korNm}</td>
                  <td>{item.jungNo}</td>
                  <td>{item.juminNo.slice(0, 6) + "-*******"}</td>
                  <td>{transformComma(item.feeMmAmt)} 원</td>
                  <td>{transformComma(item.prodCtrb)} 원</td>
                  <td>{transformComma(item.corrCtrb)} 원</td>
                  <td>{transformComma(item.yendCorrCtrb)} 원</td>
                  <td>{transformComma(item.hwangubIntr)} 원</td>
                  <td>{transformComma(item.tMonthCtrb)} 원</td>
                  <td>{item.corrRsnNm || "-"}</td>
                  <td>{item.corrAdptFrYyyymm || "-"}</td>
                  <td>{item.corrAdptToYyyymm || "-"}</td>
                  <td>{transformComma(item.nyProdCtrb)} 원</td>
                  <td>{transformComma(item.nyCorrCtrb)} 원</td>
                  <td>{transformComma(item.nyYendCorrCtrb)} 원</td>
                  <td>{transformComma(item.nyHwangubIntr)} 원</td>
                  <td>{transformComma(item.nyTMonthCtrb)} 원</td>
                  <td>{item.chwidukDt}</td>
                  <td>{item.sangsilDt}</td>
                  <td>{item.nyCorrRsnNm || "-"}</td>
                  <td>{item.nyCorrAdptFrYyyymm || "-"}</td>
                  <td>{item.nyCorrAdptToYyyymm || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </PerfectScrollbar>
      </div>


      {/* 건강보험 및 요양보험 요약 테이블 */}
      <table className="summary-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>고지인원</th>
            <th>연말정산</th>
            <th>고지금액</th>
            <th>환급금이자</th>
            <th>고지+이자 합계</th>
            <th>총계(건강+요양)</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const healthData = personList;

            //  건강
            const yendHealth = healthData.reduce((acc, cur) => acc + parseInt(cur.yendCorrCtrb || 0), 0);
            const totalHealth = healthData.reduce((acc, cur) => acc + parseInt(cur.tMonthCtrb || 0), 0);
            const totalHwangubIntr = healthData.reduce((acc, cur) => acc + parseInt(cur.hwangubIntr || 0), 0);
            const resultHealth = totalHealth + totalHwangubIntr

            // 요양
            const yendNursing = healthData.reduce((acc, cur) => acc + parseInt(cur.nyYendCorrCtrb || 0), 0);
            const totalNursing = healthData.reduce((acc, cur) => acc + parseInt(cur.nyTMonthCtrb || 0), 0);
            const totalNyHwangubIntr = healthData.reduce((acc, cur) => acc + parseInt(cur.nyHwangubIntr || 0), 0);
            const resultNursing = totalNursing + totalNyHwangubIntr;

            const totalSum = resultHealth + resultNursing;
            const totalCount = healthData.length;

            return (
              <>
                <tr>
                  <td>건강</td>
                  <td>{totalCount} 명</td>
                  <td>{yendHealth.toLocaleString()} 원</td>
                  <td>{totalHealth.toLocaleString()} 원</td>
                  <td>{totalHwangubIntr.toLocaleString()} 원</td>
                  <td>{resultHealth.toLocaleString()} 원</td>
                  <td rowSpan="2">{totalSum.toLocaleString()} 원</td>
                </tr>
                <tr>
                  <td>요양</td>
                  <td>{totalCount} 명</td>
                  <td>{yendNursing.toLocaleString()} 원</td>
                  <td>{totalNursing.toLocaleString()} 원</td>
                  <td>{totalNyHwangubIntr.toLocaleString()} 원</td>
                  <td>{resultNursing.toLocaleString()} 원</td>
                </tr>
              </>
            );
          })()}
        </tbody>
      </table>
    </div>
  );
};

export default IndividualDecisions;
